import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getAnalysisResultsForActiveAnalysisSet } from './getAnalysisResultsForActiveAnalysisSetSelector';

export const getSelectedAnalysisResult = createSelector(
  getAnalysisResultsForActiveAnalysisSet,
  (state: RootState) => state.selections.selectedCheckResultsLoadCaseGuid,
  (activeAnalysisResults, selectedLoadCaseGuid) => {
    const checkResultsForActiveLoadCase = activeAnalysisResults.find(
      (analysisResult) => analysisResult.loadCaseGuid === selectedLoadCaseGuid,
    );
    return checkResultsForActiveLoadCase !== undefined ? checkResultsForActiveLoadCase : null;
  },
);
